import { memo } from 'react';
import styled from 'styled-components';
import { Text, theme } from '@frameio/vapor';
import { QuickSearchListDivider } from '../../shared';
import TEXT from './generated/TEXT/LoadingMoreSkeleton';
import { ListSkeleton } from './ListSkeleton';

TEXT.DEFINE({
  /** Loading message shown while fetching more search results */
  title: 'Finding more results...',
});

export const LoadingMoreSkeleton = memo(() => (
  <LoadingMoreSkeletonContainer>
    <QuickSearchListDivider
      paddingX={16}
      style={{ paddingBottom: 17, marginTop: -3 }}
    />
    <LoadingMoreHeader>
      <Text color="tertiary" fontWeight="medium" variant="secondary">
        {TEXT.title}
      </Text>
    </LoadingMoreHeader>
    <ListSkeleton />
  </LoadingMoreSkeletonContainer>
));

const LoadingMoreSkeletonContainer = styled.div`
  display: flex;
  flex-direction: column;
  height: 100%;
  width: 100%;
`;

const LoadingMoreHeader = styled.div`
  margin-bottom: -2px;
  padding-left: ${theme.spaces[16]};
  padding-right: ${theme.spaces[8]};
`;
